<template>
  <div>
    <div class="row flight-route" v-for="route in flightResult.route">
      <div class="column small-4 small-order-1 medium-order-0 medium-2 small-text-right" v-html="route.logos"></div>
      <div class="column small-8 small-order-0 medium-order-1 medium-3">
        <div class="airport-name">{{route.from.departure_airport_name}}</div>
        <div class="airport-datetime text-xsmall">{{route.from.departure_date_time}}</div>
      </div>
      <div class="column small-12 small-order-2 medium-3 text-center spacer-small">
        <div class="airport-stops"  v-html="route.time_and_stops"></div>
        <div class="route-vias" @click="emitShowFlightPlan">
          <div class="via">{{ flightResult.cabin_type}}</div>
          <div class="via" v-if="route.via.length > 0">via</div>
          <div class="via" v-for="v in route.via" :title="v.name">
            {{v.name}}
          </div>
            <span class="info-icon">i</span>
        </div>
      </div>
      <div class="column small-12 medium-3 small-order-3 text-right">
        <div class="airport-name">{{route.to.destination_airport_name}}</div>
        <div class="airport-datetime  text-xsmall">{{route.to.arrival_date_time}}</div>
      </div>
    </div>
  </div>

</template>

<script>



export default {
  props: ['flightResult'],
  methods: {
    emitShowFlightPlan(){
      this.$emit('show-flight-plan', this.flightResult.flight_proposal_id)
    }
  }
}
</script>

<style>
.route-vias { position: relative;}
.info-icon {
    display: inline-block;
    border: solid 1px #cdcdcd;
    border-radius: 50%;
    width: 18px;
    height: 18px;
    font-size: 16px;
    font-family: serif;
    position: absolute;
    right: 1px;
    top: 1px;
    background: #d4b982;
        color: #fff;
}
</style>